import { tryCatchHelper } from '../../../helpers';
import {
  ACTIVO_MATERIAS,
  ALL_MATERIAS,
  LOADING_ALL_MATERIAS,
} from './MateriasReducer';
import {
  allMateriasService,
  asignarEntCarMateriasService,
  deleteEntCarMateriasService,
  deleteMateriasService,
  oneMateriasService,
  saveMateriasService,
} from './MateriasService';

export const allMateriasAction = async (dispatch, params) => {
  try {
    dispatch({ type: LOADING_ALL_MATERIAS, payload: true });
    const res = await allMateriasService(params);
    dispatch({ type: ALL_MATERIAS, payload: res.data });
    dispatch({ type: LOADING_ALL_MATERIAS, payload: false });
    return res.data;
  } catch (e) {
    dispatch({ type: LOADING_ALL_MATERIAS, payload: false });
    tryCatchHelper(e);
    return false;
  }
};

export const saveMateriasAction = async (
  { dispatch, notify },
  id,
  data,
  params,
) => {
  try {
    const res = await saveMateriasService(id, data);
    notify(res.data.message);
    await allMateriasAction(dispatch, params);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};

export const setActivoMateriasAction = async (dispatch, data) => {
  dispatch({ type: ACTIVO_MATERIAS, payload: data });
};

export const oneMateriasAction = async (dispatch, id) => {
  try {
    const res = await oneMateriasService(id);
    await setActivoMateriasAction(dispatch, res.data.data);
    return res.data;
  } catch (e) {
    tryCatchHelper(e);
    return false;
  }
};

export const deleteMateriasAction = async (
  { dispatch, notify },
  id,
  params,
) => {
  try {
    const res = await deleteMateriasService(id);
    notify(res.data.message);
    await setActivoMateriasAction(dispatch, null);
    await allMateriasAction(dispatch, params);
    return true;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};

export const asignarEntCarMateriasAction = async (
  { dispatch, notify },
  data,
) => {
  try {
    const res = await asignarEntCarMateriasService(data);
    notify(res.data.message);
    await oneMateriasAction(dispatch, data.idMateria);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};

export const deleteEntCarMateriasAction = async (
  { dispatch, notify },
  idMateria,
  id,
) => {
  try {
    const res = await deleteEntCarMateriasService(id);
    notify(res.data.message);
    await oneMateriasAction(dispatch, idMateria);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};
